import React from "react";
import { LanguageCode } from "../../../../amorg-common";
import { LanguageSelector } from "../../../../designSystem/compositeComponents/LanguageSelector";
import { PublicPageWrapper } from "../../../_pageWrappers/PublicPageWrapper";
import { amorgLocalStorage } from '../../../../utils/amorgLocalStorage';

export function SurveyAnswerPageWrapper(
    props: React.PropsWithChildren<{
        siteId: string,
        availableLanguages: LanguageCode[]
        selectedLanguage?: LanguageCode,
        onSelectedLanguageChange?: (languageCode: LanguageCode) => void,
    }>
): JSX.Element {

    const [selectedLanguage, setSelectedLanguage] = React.useState<LanguageCode>(props.availableLanguages[0]);

    React.useEffect(() => {
        const storedLanguage = amorgLocalStorage.selectedLanguage.get();
        if(storedLanguage === undefined)
        {
            const defaultLanguage = props.availableLanguages[0];
            amorgLocalStorage.selectedLanguage.set(defaultLanguage);
            setSelectedLanguage(defaultLanguage);
            if(props.onSelectedLanguageChange) {
                props.onSelectedLanguageChange(defaultLanguage);
            }
        }
        else
        {
            setSelectedLanguage(storedLanguage);
            if(props.onSelectedLanguageChange) {
                props.onSelectedLanguageChange(storedLanguage);
            }
        }
        
    }, [props.availableLanguages]);

    function handleSelectedLanguageChange(languageCode: LanguageCode) {
        setSelectedLanguage(languageCode);
        amorgLocalStorage.selectedLanguage.set(languageCode);
        if(props.onSelectedLanguageChange) {
            props.onSelectedLanguageChange(languageCode);
        }
    }

    return (
        <PublicPageWrapper
            siteId={props.siteId}
            customControls={
                (props.availableLanguages.length > 1 && selectedLanguage) 
                ?   <LanguageSelector
                        availableLanguages={props.availableLanguages}
                        selectedLanguage={selectedLanguage}
                        onSelectedLanguageChange={(languageCode) => handleSelectedLanguageChange(languageCode)} />
                :   undefined
            }>

            {props.children}
            
        </PublicPageWrapper>
    );
}
